import { File } from "../../../models/File";
import DownloadFileButton from "../../../components/DownloadFileButton";
import { Text } from "../../../design/text";

interface AttachmentListItemProps {
  attachment: File;
}

const AttachmentListItem = ({ attachment }: AttachmentListItemProps) => {
  return (
    <div className="flex items-center justify-between p-2 border-b">
      <div className="flex items-center space-x-4">
        <div>
          <Text>{attachment.name}</Text>
        </div>
      </div>
      <DownloadFileButton file={attachment} />
    </div>
  );
};

export default AttachmentListItem;
